// extracted by mini-css-extract-plugin
export default {"card":"style_card__cG79P","text":"style_text__SSQqj","button":"style_button__ROvyP","content":"style_content__1UA4C"};